import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { selectIsUnread } from './realtime'

export const selectIsChangeInboxMenuOpen = state =>
  !!state.menus.changeInboxOpen

export const selectIsMoreTicketOptionsMenuOpen = state =>
  !!state.menus.moreTicketOptionsOpen

export const selectMenuNoticeCounts = () => emptyObj

export const selectMenuAlerts = createSelector(selectIsUnread, unread => ({
  'Live Chat': unread,
}))
